import { useState } from "react";
import { X } from "lucide-react";
import { TauMark } from "./Layout";

const KEY = "parish_link_hidden";

export const ParishLink = () => {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  const toggle = (v) => { sessionStorage.setItem(KEY, v ? "1" : "0"); setHidden(v); };
  if (hidden) {
    return (
      <button onClick={() => toggle(false)} aria-label="Show parish website link" className="fixed bottom-3 left-3 z-40 grid h-7 w-7 place-items-center rounded-full bg-amber-900/25 text-amber-50 opacity-50 transition-opacity hover:opacity-100 print:hidden" data-testid="parish-link-restore">
        <TauMark className="h-4 w-4" />
      </button>
    );
  }
  return (
    <div className="group fixed bottom-3 left-3 z-40 print:hidden" data-testid="parish-link">
      <a href="https://mabuhayparish.org" target="_blank" rel="noopener noreferrer" aria-label="Visit our parish website (opens in a new tab)"
        className="flex items-center rounded-full bg-amber-900 p-1 text-amber-50 shadow-lg ring-2 ring-[#C9A227] transition-[padding] duration-300 group-hover:pr-4" data-testid="parish-link-anchor">
        <span className="grid h-8 w-8 sm:h-10 sm:w-10 shrink-0 place-items-center"><TauMark className="h-5 w-5 sm:h-6 sm:w-6" /></span>
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs font-semibold transition-[max-width] duration-300 group-hover:max-w-[22rem]">
          <span className="pl-2">Visit our parish website · mabuhayparish.org</span>
        </span>
      </a>
      <button onClick={() => toggle(true)} aria-label="Hide parish website link" className="absolute -right-1 -top-1 hidden h-5 w-5 place-items-center rounded-full bg-white text-stone-600 shadow ring-1 ring-stone-300 group-hover:grid" data-testid="parish-link-hide">
        <X className="h-3 w-3" />
      </button>
    </div>
  );
};
